export default {
    text_1: "Moje firmy - DOFFERO®",
    text_2: "Moje firmy",
    text_3: "V této sekci si můžeš přidat více firem, pod kterými chceš tvořit nabídky. Následně je můžeš používat při vytváření nabídek a budeme ti automaticky doplňovat údaje.",
    text_4: "Vytvořit novou firmu",
    text_5: "Název firmy",
    text_6: "Odpovědná osoba",
    text_7: "Upravit položku",
    text_8: "Smazat položku",
    text_9: "Jste si jistí?",
    text_10: "Opravdu chceš smazat firmu?",
    text_11: "Ne",
    text_12: "Ano",
    text_13: "Firma byla úspěšně smazána",
    text_14: "Firma byla úspěšně vytvořena",
    text_15: "Firma byla úspěšně upravena",
    text_16: 'Nová firma',
    text_17: 'Úprava firmy',
    text_18: 'NÁZEV FIRMY',
    text_19: 'Název slouží pro tvoji evidenci',
    text_20: 'ODPOVĚDNÁ / KONTAKTNÍ OSOBA',
    text_21: 'Firemní údaje',
    text_22: 'Některé údaje dokážeme vyplnit automaticky. Zadej IČO nebo název firmy.',
    text_23: 'Název společnosti',
    text_24: 'IČO',
    text_25: 'DIČ',
    text_26: 'IČ DPH',
    text_27: 'ULICE A ČÍSLO sídla firmy',
    text_28: 'PSČ sídla firmy',
    text_29: 'MĚSTO sídla firmy',
    text_30: 'Uložit firmu',

    text_31: "Vlož <b>logo firmy</b> přetažením nebo <span class='nahraj'>nahraj logo</span>",
    text_32: "Vlož <b>logo firmy</b> přetažením nebo <span class='nahraj'>nahraj logo</span>",
    text_33: "Vlož <b>logo firmy</b> přetažením nebo <span class='nahraj'>nahraj logo</span>",
    text_34: "Smazat",
    text_35: "Stáhnout",
    text_36: "Opravdu chcete smazat logo?",
    text_37: "Je možné nahrát jen jedno logo. Prosím, nejprve smažte původní.",
    text_38: "Pouze ${extensions} soubory mohou být nahrány.",
    text_39: "${name} je příliš velký! Prosím, vyberte soubor do velikosti ${size} MB.",
    text_40: "Logo firmy",
}
